// import { Injectable } from '@angular/core';
// import { Socket } from 'ngx-socket-io';
// import { environment } from 'src/environments/environment';
// import { Router } from '@angular/router';
// import { NzMessageService } from 'ng-zorro-antd/message';

// @Injectable({
//   providedIn: 'root'
// })
// export class SocketService extends Socket {
//   constructor(private router: Router, private message: NzMessageService) {
//     super({ url: `${environment.root}cms`, options: { query: {token: localStorage.getItem('token')} } });
//     this.on('error', (error) => {
//       // console.log(error);
//       if(error.type == 'UnauthorizedError') {       
//         localStorage.removeItem('token');
//         this.router.navigate(['./login']);
//         location.reload();
//       }
//     })
//   }
// }



import { Injectable, NgZone } from '@angular/core';
import { io, Socket } from 'socket.io-client';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { NzMessageService } from 'ng-zorro-antd/message';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SocketService {
  public on(event: string, callback: (...args: any[]) => void): void {
  this.socket.on(event, (...args: any[]) => {
    this.ngZone.run(() => callback(...args));
  });
}
  public socket: Socket;

  constructor(
    private router: Router,
    private message: NzMessageService,
    private ngZone: NgZone
  ) {
    this.socket = io(`${environment.root}cms`, {
      query: { token: localStorage.getItem('token') || '' },
      transports: ['websocket'], // Optional
    });

    this.socket.on('connect', () => {
      console.log('✅ WebSocket connected');
    });

    this.socket.on('error', (error: any) => {
      if (error?.type === 'UnauthorizedError') {
        localStorage.removeItem('token');
        this.router.navigate(['./login']);
        location.reload();
      }
    });

    this.socket.on('disconnect', (reason: string) => {
      this.handleDisconnection(reason);
    });
  }

  /**
   * Same as ngx-socket-io: Observable for event
   */
  public fromEvent<T = any>(eventName: string): Observable<T> {
    return new Observable<T>((subscriber) => {
      const listener = (data: T) => {
        this.ngZone.run(() => subscriber.next(data));
      };
      this.socket.on(eventName, listener);

      return () => {
        this.socket.off(eventName, listener);
      };
    });
  }

  /**
   * Same as ngx-socket-io: emit with optional callback
   */
  public emit(event: string, ...args: any[]): void {
    this.socket.emit(event, ...args);
  }

  /**
   * Used in some parts of your app: reconnect manually
   */
  public connect(): void {
    if (!this.socket.connected) {
      this.socket.connect();
    }
  }

  /**
   * Disconnect the socket
   */
  public disconnect(): void {
    this.socket.disconnect();
  }

  /**
   * Optional: Replace `ioSocket.connected` references
   */
  get ioSocket(): Socket {
    return this.socket;
  }

  private handleDisconnection(reason: string): void {
    this.message.error('WebSocket connection has been disconnected. Reason: ' + reason);
    console.warn('WebSocket connection has been disconnected. Reason: ' + reason);
  }

}